/*
 * @Author: wp
 * @Date: 2022-12-29 13:39:52
 * @LastEditors: wanpengcheng 172257193@qq.com
 * @LastEditTime: 2025-01-15 17:48:33
 * @Descripttion:
 */
export const state = () => ({
    gameList: [], // 游戏列表
    gameHotList: [], // 热门游戏列表
    goodsDealCount: 0, // 商品成交总数
    goodsTypeCateList: [], // 商品分类
    goodsListPropertyConfig: [], // 商品属性分类配置
    gameCateList: [], // 游戏分类
    goodsKey: [], // 属性对照表(需要登录--发布)
    goodsListKey: [], // 属性对照表(列表、详情)
    releaseDataObj: {}, // 发布商品的数据，发布成功后要清空
    releaseGoodsBreadcrumb: {}, // 发布时商品时的面包屑
    goodsSearchRang: [], // 区间筛选
    payInfo: {}, // 详情点击砍价信息
    latestArticlesList: [], //游戏最新文章列表
    hotArticlesList: [], //游戏热门文章列表
    gameGoodsTypeList: [], // 游戏支持的商品类型
    buyGoodsType: 6, // 商品类型
    exposureNum: { exposureNum: 1, fastSellLimitNum: 1 }, //放心购/极速卖商品每天额外赠送手动曝光次数
    recommendFilter: '',
    indexGameFilter: {},
    categoryList: [], // 商品类别列表
    releaseGoodsCatalogueId: null // 发布商品的类别ID
})
export const mutations = {
    // 获取游戏列表
    SET_GAME_LIST: (state, list) => {
        state.gameList = list
    },
    // 获取热门游戏列表
    SET_GAME_HOT_LIST: (state, list) => {
        state.gameHotList = list
    },
    // 获取游戏分类
    SET_GAME_CATE_LIST: (state, list) => {
        state.gameCateList = list
    },
    // 获取商品分类
    SET_GOODS_TYPE_CATE_LIST: (state, list) => {
        state.goodsTypeCateList = list
    },
    // 商品成交总数
    SET_GOODS_DEAL_COUNT: (state, count) => {
        state.goodsDealCount = count
    },
    // 获取区间筛选
    SET_SEARCH_RANG: (state, list) => {
        state.goodsSearchRang = list
    },
    // 获取商品属性分类配置
    SET_GOODS_LIST_PROPERTY_CONFIG: (state, list) => {
        console.log('===============9999', list)
        state.goodsListPropertyConfig = list
        console.log('state.goodsListPropertyConfig', state.goodsListPropertyConfig)
    },
    // 获取发布时商品时的面包屑
    SET_RELEASE_BREADCRUMB: (state, obj) => {
        state.releaseGoodsBreadcrumb = obj
    },
    // 获取属性对照表(需要登录--发布)
    SET_GOODS_KEY: (state, list) => {
        state.goodsKey = list
    },
    // 获取属性对照表(列表、详情)
    SET_GOODS_LIST_KEY: (state, list) => {
        state.goodsListKey = list
    },
    // 详情点击砍价信息
    SET_PAY_INFO: (state, info) => {
        state.payInfo = info
    },
    // 发布商品的数据，发布成功后要清空
    SET_RELEASE_DATA: (state, obj) => {
        const copyObj = JSON.parse(JSON.stringify(obj));
        if (copyObj.gameId) {
            state.releaseDataObj[copyObj.gameId.toString()] = copyObj
            state.releaseDataObj.currentId = copyObj.gameId
            // 设置发布商品数据的时候顺便设置发布商品的类别ID 为什么不就用releaseDataObj呢 因为这个字段发布完商品要清空 但是发布结果页我需要这个字段来判断是否显示选择区服步骤
            state.releaseGoodsCatalogueId = copyObj?.goodsCatalogueId || null
        } else {
            state.releaseDataObj = {}
        }
    },
    // 发布成功后要清空
    CLEAR_RELEASE_DATA: (state, gameId) => {
        if (gameId) {
            delete state.releaseDataObj[gameId.toString()];
            delete state.releaseDataObj.currentId;
        }
    },
    // 设置发布商品的类别ID
    SET_RELEASE_GOODS_CATALOGUE_ID: (state, id) => {
        state.releaseGoodsCatalogueId = id
    },
    // 获取最新文章列表
    SET_LATEST_ARTICLES_LIST: (state, obj) => {
        state.latestArticlesList = JSON.parse(JSON.stringify(obj))
    },
    // 获取热门文章列表
    SET_HOT_ARTICLES_LIST: (state, obj) => {
        state.hotArticlesList = JSON.parse(JSON.stringify(obj))
    },
    // 获取游戏支持的商品类型
    SET_GAME_GOODS_TYPE_LIST: (state, list) => {
        state.gameGoodsTypeList = list
    },
    // 保存我要买业务线的商品类型
    SET_BUY_GOODS_TYPE: (state, type) => {
        state.buyGoodsType = type ? parseInt(type) : 6
    },
    // 获取商品每天额外赠送手动曝光次数
    SET_GOODS_EXPOSURE_NUM: (state, obj) => {
        state.exposureNum = obj
    },
    // 首页推荐游戏携带筛选项
    SET_INDEX_RECOMMEND_FILTER: (state, val) => {
        state.recommendFilter = val
    },
    // 新-首页推荐游戏携带筛选项
    SET_INDEX_GAME_FILTER: (state, val) => {
        state.indexGameFilter = val
    },
    // 设置商品类别列表
    SET_CATEGORY_LIST: (state, categories) => {
        state.categoryList = categories || []
    },
    // 重置发布步骤相关数据
    RESET_RELEASE_STEPS: (state) => {
        state.categoryList = []
    }
}
export const actions = {
    // 所有游戏
    GameList({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            const action = { action: { ...params, goodsCatalogueId: 6 } }
            this.$api
                .gameAll(action)
                .then(response => {
                    const data = response.data
                    //
                    commit('SET_GAME_LIST', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 热门游戏
    GameHotList({ commit }, data) {
        return new Promise((resolve, reject) => {
            this.$api
                .gamePopular({
                    action: {
                        ...data
                    }
                })
                .then(response => {
                    const data = response.data
                    commit('SET_GAME_HOT_LIST', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 游戏类型（端游、手游）
    GameCateList({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .gameAllCatalogue()
                .then(response => {
                    const data = response.data
                    commit('SET_GAME_CATE_LIST', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 商品类型（ID、账户）
    GoodsTypeCateList({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .goodsCatalogue()
                .then(response => {
                    const data = response.data

                    commit('SET_GOODS_TYPE_CATE_LIST', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 根据游戏获取该游戏支持的商品类型
    getGameGoodsTypeList({ commit }, params) {
        return new Promise((resolve, reject) => {
            this.$api
                .listGoodsCatalogueBySearch(params)
                .then(res => {
                    if (res.success) {
                        commit('SET_GAME_GOODS_TYPE_LIST', res.data)
                    }
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 获取商品全部的属性名称配置
    ListGoodsPropertyConfigBySearch({ commit }, p) {
        p.action.inSell = true
        return new Promise((resolve, reject) => {
            this.$api
                .listGoodsPropertyConfigBySearch(p)
                .then(response => {
                    console.log('================8888888', response)
                    const data = response.data
                    commit('SET_GOODS_LIST_PROPERTY_CONFIG', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 客服售前售后链接
    CustomerServiceConfig({ commit }, data) {
        return new Promise((resolve, reject) => {
            this.$api
                .customerServiceConfig(data)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 商品属性对照表（发布）
    GoodsKey({ commit }, params) {
        return new Promise((resolve, reject) => {
            this.$api
                .listGoodsPropertyConfig(params)
                .then(response => {
                    const data = response.data
                    let _arr = JSON.parse(JSON.stringify(response.data))
                    let _sellMethod = null
                    _arr.map((item, index) => {
                        if (item.mappingField == 'sellMethod') {
                            _sellMethod = item
                            _arr.splice(index, 1)
                        }
                    })
                    if (_sellMethod) {
                        _arr.unshift(_sellMethod)
                    }

                    commit('SET_GOODS_KEY', _arr)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 商品属性对照表（列表、详情）
    GoodsListKey({ commit }, params) {
        return new Promise((resolve, reject) => {
            this.$api
                .goodsListPropertyConfig(params)
                .then(response => {
                    const data = response.data
                    commit('SET_GOODS_LIST_KEY', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 获取最新文章列表
    GameLatestArticlesList({ commit }, params) {
        return new Promise((resolve, reject) => {
            const latestArticles = {
                // action: {},
            }
            // 是否去掉当前文章
            if (params) latestArticles.id = params.excludeId
            this.$api
                .articleNewAPI(latestArticles)
                .then(response => {
                    const data = response.data
                    commit('SET_LATEST_ARTICLES_LIST', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 获取热门文章列表
    GameHotArticlesList({ commit }, params) {
        return new Promise((resolve, reject) => {
            const hotArticles = {
                // action: {},
            }
            // 是否去掉当前文章
            if (params) hotArticles.id = params.excludeId
            this.$api
                .articleHotAPI(hotArticles)
                .then(response => {
                    const data = response.data
                    commit('SET_HOT_ARTICLES_LIST', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 获取每天额外赠送手动曝光次数
    ExposureNum({ commit }) {
        return new Promise((resolve, reject) => {
            this.$api
                .exposureNum()
                .then(response => {
                    const data = response.data
                    commit('SET_GOODS_EXPOSURE_NUM', data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 获取商品类别列表
    getCategoryList({ commit }, gameId) {
        return this.$api.getPublishGeneralCatalogue({ gameId }).then(res => {
            commit('SET_CATEGORY_LIST', res.data)
            return res.data
        })
    }
}
export const getters = {
    gameList: state => state.gameList,
    gameHotList: state => state.gameHotList,
    gameCateList: state => state.gameCateList,
    goodsDealCount: state => state.goodsDealCount,
    goodsTypeCateList: state => state.goodsTypeCateList,
    goodsSearchRang: state => state.goodsSearchRang,
    goodsListPropertyConfig: state => state.goodsListPropertyConfig,
    releaseDataObj: state => state.releaseDataObj,
    goodsKey: state => state.goodsKey,
    releaseGoodsBreadcrumb: state => state.releaseGoodsBreadcrumb,
    payInfo: state => state.payInfo,
    latestArticlesList: state => state.latestArticlesList,
    hotArticlesList: state => state.hotArticlesList,
    gameGoodsTypeList: state => state.gameGoodsTypeList,
    buyGoodsType: state => state.buyGoodsType,
    exposureNum: state => state.exposureNum,
    recommendFilter: state => state.recommendFilter,
    indexGameFilter: state => state.indexGameFilter,
    // 获取商品类别列表
    categoryList: state => state.categoryList
}
